import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "condition-layout" }

import { PropType, computed } from 'vue'
import { ConditionsTemplateModel } from '@/types';
    
export default /*#__PURE__*/_defineComponent({
  props: {
        condition: {type: String, required: true},
        treatment: {type: Object as PropType<ConditionsTemplateModel>, required: true}
    },
  setup(__props) {

const props = __props



    const getTreatment = computed(() => {
        if (props.treatment !== undefined) {
            return props.treatment.list1
        } else {
            return []
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(__props.condition), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTreatment), (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}
}

})